/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Vimeo_LabelInputs */

const en_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo Page URL`)
};

const fr_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la page Vimeo`)
};

const de_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo-Seiten-URL`)
};

const it_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL della pagina Vimeo`)
};

const ru_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL страницы Vimeo`)
};

const es_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la página de Vimeo`)
};

const zh_cn2_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo 页面网址`)
};

const ja_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VimeoページのURL`)
};

const hi_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo पेज URL`)
};

const pt_pt2_media_import_vimeo_label = /** @type {(inputs: Media_Import_Vimeo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL da página do Vimeo`)
};

/**
* | output |
* | --- |
* | "Vimeo Page URL" |
*
* @param {Media_Import_Vimeo_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_vimeo_label = /** @type {((inputs?: Media_Import_Vimeo_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Vimeo_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_vimeo_label(inputs)
	if (locale === "de") return de_media_import_vimeo_label(inputs)
	if (locale === "it") return it_media_import_vimeo_label(inputs)
	if (locale === "ru") return ru_media_import_vimeo_label(inputs)
	if (locale === "es") return es_media_import_vimeo_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_vimeo_label(inputs)
	if (locale === "ja") return ja_media_import_vimeo_label(inputs)
	if (locale === "hi") return hi_media_import_vimeo_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_vimeo_label(inputs)
	return en_media_import_vimeo_label(inputs)
});